import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteWorkflowStageArguments {
  params: OpalApiRequestParams<'DeleteWorkflowStageV3'>
}

export async function deleteWorkflowStage({
  params,
}: DeleteWorkflowStageArguments): Promise<null> {
  const url = new URL(
    `/v3/workflow_stages/${params.path.workflow_stage_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
